import { AnyAction } from 'redux'
import {
    CURRENT_MEETING_SET,
    CURRENT_MEETING_CLOSED,
    MEETING_CANNOT_START,
    UPDATE_LOCALE_STARTED_DATE,
    MEETINGS_NETWORK_TEST_SET,
    MEETING_STARTED_CONSULTATION_SUCCESS,
    MEETING_STARTED_CONSULTATION_LEAVE,
    MEETING_TOTAL,
    FORCE_CONSULTATIONS_PAGE_TAB,
} from '../actions/types'

interface MeetingStore {
    list: any
    eventEmitterList: any
    userUsageInfoEventEmitter: any
    current: any
    meetCanotStart: boolean
    shouldRunNetwortkTest: boolean
    startedConsultationList: any
    isLoadingPendingConsultation: boolean
    isLoadingStartedConsultation: boolean
    totalTlc: number
    pendingActsReceived: Array<any>
    consultationsPageForcedTab: any
}

const INITIAL_STATE: MeetingStore = {
    list: {},
    eventEmitterList: {},
    userUsageInfoEventEmitter: null,
    current: null,
    meetCanotStart: false,
    shouldRunNetwortkTest: false,
    startedConsultationList: {},
    isLoadingPendingConsultation: false,
    isLoadingStartedConsultation: false,
    totalTlc: 0,
    pendingActsReceived: [],
    consultationsPageForcedTab: null,
}

export default (state = INITIAL_STATE, action: AnyAction): MeetingStore => {
    let list = {}
    let startedConsultationList = {}
    switch (action.type) {
        case CURRENT_MEETING_SET:
            list = {
                ...state.list,
            }
            Reflect.deleteProperty(list, action.payload.objectId)
            return {
                ...state,
                current: action.payload,
                list,
                meetCanotStart: false,
            }
        case CURRENT_MEETING_CLOSED:
            return {
                ...state,
                current: null,
            }
        case UPDATE_LOCALE_STARTED_DATE:
            return {
                ...state,
                current: {
                    ...state.current,
                    startedDate: action.payload.startedDate,
                },
            }
        case MEETING_CANNOT_START:
            return {
                ...state,
                meetCanotStart: true,
            }
        case MEETINGS_NETWORK_TEST_SET:
            return {
                ...state,
                shouldRunNetwortkTest: action.payload,
            }
        case MEETING_STARTED_CONSULTATION_SUCCESS:
            return {
                ...state,
                startedConsultationList: {
                    ...state.startedConsultationList,
                    [action.payload.key]: action.payload.startedConsultation,
                },
            }
        case MEETING_STARTED_CONSULTATION_LEAVE:
            startedConsultationList = {
                ...state.startedConsultationList,
            }
            delete startedConsultationList[action.payload]
            return {
                ...state,
                startedConsultationList,
            }
        case MEETING_TOTAL:
            return {
                ...state,
                totalTlc: action.payload,
            }
        case FORCE_CONSULTATIONS_PAGE_TAB:
            return {
                ...state,
                consultationsPageForcedTab: action.payload,
            }
        default:
            return state
    }
}
